import anime from 'animejs';
import { keyframes } from 'styled-components';

export const jumpingElements = (selector: any, onComplete: any) => {
  anime({
    targets: selector,
    translateY: -25,
    delay: (el: any, i: any) => i * 100,
    loop: 2,
    complete: onComplete,
  });
};

export const fadeIn = (selector: any, options = {}) => {
  anime({
    targets: selector,
    opacity: [0, 1],
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'translateX' does not exist on type '{}'.
    translateX: options.translateX ? options.translateX : 0,
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'translateY' does not exist on type '{}'.
    translateY: options.translateY ? options.translateY : ['100vh', '0'],
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'duration' does not exist on type '{}'.
    duration: options.duration ? options.duration : 500,
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'easing' does not exist on type '{}'.
    easing: options.easing ? options.easing : 'easeInQuad',
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'onComplete' does not exist on type '{}'.
    complete: options.onComplete ? options.onComplete : () => {},
  });
};

export const fadeOut = (selector: any, options = {}) => {
  anime({
    targets: selector,
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'duration' does not exist on type '{}'.
    duration: options.duration ? options.duration : 500,
    opacity: [1, 0],
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'translateY' does not exist on type '{}'.
    translateY: options.translateY ? options.translateY : ['0', '100vh'],
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'easing' does not exist on type '{}'.
    easing: options.easing ? options.easing : 'easeInQuad',
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'onComplete' does not exist on type '{}'.
    complete: options.onComplete ? options.onComplete : () => {},
  });
};

export const fadeUp = keyframes`
  from {
    transform: translateY(100px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const fadeOutWithoutTranslating = (selector: any, options = {}) => {
  anime({
    targets: selector,
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'duration' does not exist on type '{}'.
    duration: options.duration ? options.duration : 500,
    opacity: [1, 0],
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'easing' does not exist on type '{}'.
    easing: options.easing ? options.easing : 'easeInQuad',
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'onComplete' does not exist on type '{}'.
    complete: options.onComplete ? options.onComplete : () => {},
  });
};

export const slideIn = (selector: any, options = {}) => {
  anime({
    targets: selector,
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'duration' does not exist on type '{}'.
    duration: options.duration ? options.duration : 500,
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'translateX' does not exist on type '{}'.
    translateX: options.translateX ? options.translateX : ['100vw', '0'],
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'easing' does not exist on type '{}'.
    easing: options.easing ? options.easing : 'linear',
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'onComplete' does not exist on type '{}'.
    complete: options.onComplete ? options.onComplete : () => {},
  });
};
